import React from 'react'

import { Global } from '@emotion/react'
import { Color, Text, useTheme, ZIndex } from '@gousto-internal/citrus-react'
import RCTooltip from 'rc-tooltip'

type ProductButtonTooltipProps = {
  children: React.ReactElement
  message: string
  visible: boolean
}

const PRODUCT_BUTTON_TOOLTIP_CLASS = 'product-button-tooltip'

export const ProductButtonTooltip = ({ children, message, visible }: ProductButtonTooltipProps) => {
  const { theme } = useTheme()
  const tooltipBackground = theme.color(Color.ColdGrey_900)

  return (
    <>
      <Global
        styles={{
          [`.${PRODUCT_BUTTON_TOOLTIP_CLASS}`]: {
            backgroundColor: 'transparent',
            opacity: 1,
          },
          [`.${PRODUCT_BUTTON_TOOLTIP_CLASS} .rc-tooltip-inner`]: {
            backgroundColor: tooltipBackground,
            borderRadius: theme.spacing(2),
            boxShadow: '0 8px 16px rgba(24, 32, 48, 0.18)',
            maxWidth: '240px',
            minHeight: 'auto',
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
            textAlign: 'left',
            width: 'max-content',
          },
          [`.${PRODUCT_BUTTON_TOOLTIP_CLASS}.rc-tooltip-placement-top .rc-tooltip-arrow`]: {
            borderTopColor: tooltipBackground,
          },
        }}
      />
      <RCTooltip
        overlay={
          visible ? (
            <Text color={Color.White} size={1}>
              {message}
            </Text>
          ) : null
        }
        overlayClassName={PRODUCT_BUTTON_TOOLTIP_CLASS}
        overlayStyle={{
          pointerEvents: 'none',
          zIndex: theme.zIndex(ZIndex.Top),
        }}
        placement="top"
        trigger={[]}
        visible={visible}
      >
        {children}
      </RCTooltip>
    </>
  )
}
